import {
    TClientCategory,
    TGlobalCategoriesResponse,
    TGlobalCategory,
    TGlobalCategoryRequest,
} from 'types';
import { cdmApi } from '.';

const PREFIX = '/global-categories';

const keywordsApi = cdmApi.injectEndpoints({
    endpoints: (builder) => ({
        getGlobalCategories: builder.query<TGlobalCategoriesResponse, void>({
            query: (params) => ({ url: PREFIX, method: 'get', params }),
            providesTags: () => [{ type: 'ClientCategories', id: 'LIST' }],
        }),

        getClientCategoryById: builder.query<TGlobalCategory, number>({
            query: (globalCategoryId) => ({ url: `${PREFIX}/${globalCategoryId}`, method: 'get' }),
            providesTags: () => [{ type: 'ClientCategories', id: 'LIST' }],
        }),

        getClientCategories: builder.query<TClientCategory[], { hasParent?: boolean }>({
            query: (params) => ({ url: `${PREFIX}/client-categories`, method: 'get', params }),
            providesTags: () => [{ type: 'ClientCategories', id: 'LIST' }],
        }),

        updateClientCategory: builder.mutation<any, { data: TGlobalCategoryRequest; globalCategoryId: number }>({
            query: ({ globalCategoryId, data }) => ({
                url: `${PREFIX}/client-categories/${globalCategoryId}`,
                method: 'put',
                data,
            }),
            invalidatesTags: [{ type: 'ClientCategories', id: 'LIST' }],
        }),

        deleteGlobalCategory: builder.mutation<any, number[]>({
            query: (globalCategoriesIds) => ({
                url: `${PREFIX}/client-categories/`,
                method: 'delete',
                data: { global_categories_ids: globalCategoriesIds },
            }),
            invalidatesTags: [{ type: 'ClientCategories', id: 'LIST' }],
        }),

        createGlobalCategory: builder.mutation<TGlobalCategoryRequest, any>({
            query: (data) => ({
                url: `${PREFIX}/client-categories`,
                method: 'post',
                data,
            }),
            invalidatesTags: [{ type: 'ClientCategories', id: 'LIST' }],
        }),

        uploadGlobalCategories: builder.mutation<any, FormData>({
            query: (data) => ({ url: `${PREFIX}/excel/upload`, method: 'POST', data }),
            invalidatesTags: [{ type: 'ClientCategories', id: 'LIST' }],
        }),

        exportCategories: builder.query<ArrayBuffer, void>({
            query: (params) => ({
                url: `${PREFIX}/excel/export`,
                method: 'get',
                params,
                responseType: 'arraybuffer',
            }),
        }),

        downloadGlobalCategoriesErrorFile: builder.query<ArrayBuffer, { [key: string]: any }>({
            query: (data) => ({
                url: `${PREFIX}/excel/errors/export`,
                method: 'POST',
                data,
                responseType: 'arraybuffer',
            }),
        }),
    }),

    overrideExisting: false,
});

export const {
    useGetGlobalCategoriesQuery,
    useGetClientCategoriesQuery,
    useLazyGetClientCategoryByIdQuery,
    useCreateGlobalCategoryMutation,
    useUpdateClientCategoryMutation,
    useDeleteGlobalCategoryMutation,
    useUploadGlobalCategoriesMutation,
    useLazyExportCategoriesQuery,
    useLazyDownloadGlobalCategoriesErrorFileQuery,
} = keywordsApi;
